import { createFilterStore } from './createFilterStore';

export const useContactFilterStore = createFilterStore({
  page: 1,
  limit: 20,
  search: '',
  companyId: '',
  sortBy: 'createdAt',
  sortOrder: 'desc' as const,
});
